var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { DraftLoadingScene } from './scenes/loading/DraftLoadingScene';
import { DraftCenterQuestionScene } from './scenes/showQuestion/DraftCenterQuestionScene';
import { Scene } from '../../../classes/learnware/LearnwareEnums';
import { runtime } from '../../../classes/runtime/Runtime';
let DraftStage_Scenes = class DraftStage_Scenes extends React.PureComponent {
    render() {
        const { app } = this.props;
        const { currentScene } = app.stage.stageScene;
        if (currentScene === Scene.Loading) {
            return React.createElement(DraftLoadingScene, { app: app });
        }
        if (currentScene === Scene.Empty) {
            return null;
        }
        if (currentScene === Scene.PreviewQuestion) {
            return React.createElement(DraftCenterQuestionScene, { question: app.edit.editCenter.centerEditItem });
        }
        /*
        if (currentScene === Scene.History) {
          return <DraftCenterQuestionScene question={app.answer.question} />;
        }
    */
        if (currentScene === Scene.NoMoreQuestions) {
            if (!runtime.streamedPackages.Lazy)
                return null;
            const { NoMoreQuestionsScene } = runtime.streamedPackages.Lazy.components;
            return React.createElement(NoMoreQuestionsScene, { app: app });
        }
        if (currentScene === Scene.ShowQuestion) {
            return React.createElement(DraftCenterQuestionScene, { question: app.answer.question });
        }
        return 'Ungültige Szene';
    }
    componentDidMount() {
        this.props.app.appBoot.onReachedContentRendered();
    }
};
DraftStage_Scenes = __decorate([
    observer
], DraftStage_Scenes);
export { DraftStage_Scenes };
